/**
 * Adds a button to a given .RB_PC_Media element if it doesn't already have one.
 * @param {Element} mediaElement The .RB_PC_Media element.
 */
function addMediaButton(mediaElement) {
  if (mediaElement.querySelector('.RB_PC_Add_Button')) {
    // Button already exists, do nothing.
    return;
  }

  const lang = document.documentElement.lang.split('-')[0] || "en";

  const translations = {
    en: { add: 'Add', remove: 'Remove' },
    fr: { add: 'Ajouter', remove: 'Supprimer' },
    sv: { add: 'Lägg till', remove: 'Ta bort' },
    es: { add: 'Añadir', remove: 'Eliminar' },
    pt: { add: 'Adicionar', remove: 'Remover' },
    fi: { add: 'Lisää', remove: 'Poista' },
    no: { add: 'Legg til', remove: 'Fjern' },
    it: { add: 'Aggiungi', remove: 'Rimuovi' }
  };
  const buttonTexts = translations[lang] || translations.en;

  const button = document.createElement('button');
  button.classList.add('RB_PC_Add_Button');
  button.classList.add('button');
  button.classList.add('accent'); //Initial state is accented (green for PC3D)

  button.textContent = buttonTexts.add;
  mediaElement.appendChild(button);

  button?.addEventListener("click", () => {
    const checkbox = mediaElement.querySelector(".RB_PC_Media_Checkbox");
    if (checkbox) {
      checkbox.dispatchEvent(new Event('click', { bubbles: true }));
    }
    button.classList.toggle("accent");
    if (button.classList.contains("accent")) {
      button.textContent = buttonTexts.add;
    } else {
      button.textContent = buttonTexts.remove;
    }
  });
}

/**
 * Handles mutations to find and process newly added .RB_PC_Media elements.
 * @param {MutationRecord[]} mutationsList The list of mutations.
 */
function handleMutations(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a .wcpb_ao_section or contains them
          if (node.matches('.wcpb_ao_section')) {
            node.querySelectorAll('.RB_Product_Card').forEach(addMediaButton);
          }

          // Check if the added node is a .RB_PC_Media inside a .wcpb_ao_section
          if (node.matches('.RB_Product_Card') && node.closest('.wcpb_ao_section')) {
            addMediaButton(node);
          }

          // Check for .RB_PC_Media elements within any added node
          node.querySelectorAll('.RB_Product_Card').forEach(mediaElement => {
            if (mediaElement.closest('.wcpb_ao_section')) {
              addMediaButton(mediaElement);
            }
          });
        }
      });
    }
  }
}

// Create a MutationObserver to watch for dynamically added elements.
const observer = new MutationObserver(handleMutations);

// Start observing the entire document body for changes.
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also, process any elements that are already on the page when the script loads.
document.querySelectorAll('.wcpb_ao_section RB_Product_Card').forEach(addMediaButton);








// --------------------------------------------------
// Set properties[_source] => "p_1058" when elnacional cookie is set
// --------------------------------------------------

const elNacionalId = "p_1058"
function setSourceValueToElnacional(root = document) {
  const selector = 'fieldset.product-form__input.product-information--line-item input[name="properties[_source]"]';
  root.querySelectorAll(selector).forEach(input => {
    try {
      if (input && input.value !== elNacionalId) {
        input.value = elNacionalId;
        // Notify any listeners (some libraries listen for input/change)
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {
      // Defensive: ignore any readonly or other assignment errors
      // (shouldn't usually happen for hidden inputs)
    }
  });
}

// Helper: check for elnacional cookie (accepts both ':' and '=' styles)
function hasElnacionalCookie() {
  try {
    const c = document.cookie || '';
    return c.includes('elnacional=true');
  } catch (e) {
    return false;
  }
}

// Observe for dynamically added fieldsets/inputs and update them
const sourceObserver = new MutationObserver(mutations => {
  for (const m of mutations) {
    if (m.type === 'childList') {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        // If the added node itself contains matching inputs, update them
        setSourceValueToElnacional(node);

        // If the added node is the fieldset itself, update directly
        if (node.matches && node.matches('fieldset.product-form__input.product-information--line-item')) {
          setSourceValueToElnacional(node);
        }
      });
    }
  }
});

sourceObserver.observe(document.body, { childList: true, subtree: true });

// Only run the initial updater and start observing when the elnacional cookie is present
if (hasElnacionalCookie()) {
  // Run once for existing inputs
  setSourceValueToElnacional();

  // Start observing for dynamically added inputs
  sourceObserver.observe(document.body, { childList: true, subtree: true });
}